
export const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to read file'));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const getMimeTypeFromBase64 = (base64: string): string => {
  return base64.substring(base64.indexOf(':') + 1, base64.indexOf(';'));
};

export const getBase64Data = (base64: string): string => {
  return base64.split(',')[1];
};
